import { useMutation, useQueryClient } from '@tanstack/react-query'
import { request } from 'Lib/axios'
import { useUserStore } from 'Stores/userStoreModuleFed'

export type RevokeCancelationType = {
  subscriptionId: string
  currentPeriodEnd: number
}

const revokeCancelation = () => {
  const { accountId } = useUserStore.getState()
  return request<{ data: RevokeCancelationType }>({
    method: 'PUT',
    url: `accounts/${accountId}/subscriptions/revoke`,
  })
}

export const useRevokeCancelation = () => {
  const queryClient = useQueryClient()
  return useMutation(revokeCancelation, {
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['getPlansDetails'] })
      void queryClient.invalidateQueries({ queryKey: ['userAccounts'] })
    },
  })
}
